/* eslint-disable react-hooks/exhaustive-deps */
// import { DialogProvider } from "./context/DialogProvider";
import { Outlet, useLocation } from "react-router-dom";
import { useIsLocationAllowed } from "./hooks/useIsLocationAllowed";
import { onAuthStateChanged, getAuth } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { firestore } from "@/helpers/firebase";
import { useSignedInNavigation } from "./hooks/useSignedInNavigation";
import { useEffect } from "react";
// import { isMyAppWKWebView } from "./bridge/isMyAppWKWebView";
import { callFirebaseFunction } from "./bridge/callFirebaseFunction";
// import { SharedAlertDialog } from "./components/SharedAlertDialog";
// import { LocationModal } from "@/components/LocationModal";
import { getStateCode } from "@/helpers/getStateCode";
import { LocationType } from "@/context/LocationContext";
import posthog from "posthog-js";
import { type Page, SIGNED_IN_ROUTES } from "@skillscratch/shared-types";
// import type { Page } from "@skillscratch/shared-types";
import { Sidebar } from "./components/Sidebar";
import { useState } from "react";
// import { AnimatePresence } from "framer-motion";
// import { useIsBackViewTransition } from "./hooks/useIsBackViewTransition";
import Intercom from "@intercom/messenger-js-sdk";
import { useModal } from "./hooks/useModal";
import { LocationModal } from "./components/Modals/LocationModal";
import { PersistentData } from "@/helpers/PersistentData";
import { updateProfile } from "firebase/auth";


// Define the types for our API calls
type UpdateUserPrivateInfoRequest = {
  updates: Partial<{
    firstName?: string;
    lastName?: string;
    state?: string;
  }>;
};

type UpdateUserPrivateInfoResponse = {
    success: boolean;
};

/**
 * Interface for IP location response
 */
interface IPStateResponse {
  ip: string;
  state: string | null;
  country: string;
  countryCode: string;
  message?: string;
}

// let retryCount = 0;
// const maxRetries = 3;

export function Layout() {
  const [isLocationAllowed, isLocationLoading, , refreshLocation, setLocation] = useIsLocationAllowed();
  const { navigateToSignedInPage, setSignedInNavigationPage } = useSignedInNavigation();
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [ranIpAddress, ] = useState(false);
  const location = useLocation();

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
      const unsubscribe = onAuthStateChanged(getAuth(), async (user) => {
          // setTimeout(() => {
          //   if (retryCount >= maxRetries) {
          //     return;
          //   }

          //   retryCount++;

          //   if (isLocationAllowed === undefined && !onBrowser) {
          //     refreshLocation(true);
          //   }
          // }, 3000);

          if (!isLocationAllowed) {
            return;
          }

          if (isLocationAllowed.type === LocationType.LocationPermissions && !isLocationAllowed.allowed) {
            navigateToSignedInPage(SIGNED_IN_ROUTES.SKILLSCRATCH_UNAVAILABLE);
            return;
          }

          if (user) {
            console.log('[loggedIn]');

              if (location.pathname === "/replays" || location.pathname === 'game-replay' || location.pathname === 'test-game') {
                  return;
              }

              const { uid, displayName } = user;
              posthog.identify(uid);

              try {
                const userDocRef = doc(firestore, "user", user.uid);

                const [firstName, lastName, phoneNumber, userDoc] = await Promise.all([
                  PersistentData.get("firstName") ?? '',
                  PersistentData.get("lastName") as Promise<string | undefined> ?? '',
                  PersistentData.get("phoneNumber"),
                  getDoc(userDocRef),
                ]);

                const userData = userDoc.data();
  
                Intercom({
                  app_id: "zm7q6jbf",
                  user_id: uid,
                  name: displayName ?? firstName as string, // null is okay to pass in
                });

                if (userData?.newLoggedInNavigationPage) {
                  navigateToSignedInPage(userData.newLoggedInNavigationPage as Page);
                  return;
                }

                const hasFreeTrial = true;

                const updates = {
                  firstName,
                  lastName,
                  state: isLocationAllowed?.locationName ?? "Unknown",
                  subscriptionsEnabled: true,
                  subscribedDollars: hasFreeTrial ? 15 : 0,
                }

                await Promise.all([
                  updateProfile(user, { displayName: firstName }),
                  callFirebaseFunction<UpdateUserPrivateInfoRequest, UpdateUserPrivateInfoResponse>(
                    "updateUserPrivateInfo",
                    { updates }
                  ),
                ]);

                posthog.capture('freetrial_test', {
                  freetrial: hasFreeTrial,
                });

                if (hasFreeTrial) {
                  // @ts-expect-error Meta pixel
                  fbq('track', 'StartTrial', {value: '0.00', currency: 'USD', predicted_ltv: '0.00'});
                }

                // @ts-expect-error Meta pixel
                fbq('track', 'CompleteRegistration');

                setSignedInNavigationPage(SIGNED_IN_ROUTES.INDEX, user.uid);


                const userInfo = [
                  `${firstName} ${lastName}`,
                  phoneNumber ?? user.phoneNumber ?? 'Unknown',
                  isLocationAllowed.locationName ?? 'Unknown'
                ].join(' | ');

                await posthog.capture("user_signup", {
                  distinctId: user.uid,
                  additional_properties: userInfo,
                });
                
                // callFirebaseFunction("updateDailyStatus", null);
                // navigateToSignedInPage(userData.newLoggedInNavigationPage as Page);
                // else {
                //   if (userData?.tutorialFinished !== undefined || userData?.signedInNavigationPage !== undefined || 
                //     userData?.loggedInNavigationPage !== undefined || userData?.newLoggedInNavigationPage) {
                //     // callFirebaseFunction("updateDailyStatus", null);
                //     navigateToSignedInPage(SIGNED_IN_ROUTES.INDEX);
                //     return;
                //   }
                  
                //   const utmSource: string | null = localStorage.getItem("utm_source");

                //   if (utmSource) {
                //     if (!userData?.utm_source) {
                //       const utmParams: Record<string, string> = {};
                  
                //       for (let i = 0; i < localStorage.length; i++) {
                //         const key: string | null = localStorage.key(i);
                //         if (key?.startsWith("utm_")) {
                //           const value: string | null = localStorage.getItem(key);
                //           if (value !== null) {
                //             utmParams[key] = value;
                //           }
                //         }
                //       }
                  
                //       utmParams.utm_timestamp = new Date().toISOString();
                //       await updateDoc(userDocRef, utmParams);
                //     }
                //   }


        
                //   navigateToSignedInPage(SIGNED_IN_ROUTES.INDEX);
                // }
              } catch {
                // navigateToSignedInPage(SIGNED_IN_ROUTES.INDEX);
              }
          } else {
            // @ts-expect-error Meta pixel
            fbq('track', 'Lead');
            navigateToSignedInPage(SIGNED_IN_ROUTES.HOME);
          }
      });

      return unsubscribe;
  }, [isLocationAllowed, isLocationLoading]);

  const { openModal } = useModal();

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (isLocationAllowed?.allowed) {
      return;
    }

    const postIpStateHandler = () => {
      refreshLocation(true).then(() => {
      // setRanIpAddress(true);
      })
    }

    setIpState(setLocation, postIpStateHandler);
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (isLocationAllowed?.allowed || !ranIpAddress) {
      return;
    }

    console.log('[isLocationAllowed openModal]', isLocationAllowed);

    openModal(<LocationModal />);
  }, [isLocationAllowed, ranIpAddress]);

  return (
    // <ModalProvider>
    <>
      <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
      <Outlet key={location.pathname} context={{ sidebarOpen, setSidebarOpen }} />
    </>
    // </ModalProvider>
  );
};

    // <DialogProvider>
    //   <Outlet />
    //   <SharedAlertDialog />
    // </DialogProvider>

function setIpState(setLocation: (location: string, type: LocationType) => void, postIpStateHandler: () => void) {
    const fetchIpState = async () => {
        try {
            const IpResponse = await callFirebaseFunction<null, IPStateResponse>(
                "getIpState",
                null
            );

            console.log('[ipState]', IpResponse.state);
            console.log('[getStateCode]', getStateCode(IpResponse?.state || ""));
        
            if (getStateCode(IpResponse?.state || "")) {
                setLocation(getStateCode(IpResponse?.state || "") || "", LocationType.Ip);
                return;
            }

            if (getStateCode(IpResponse?.country || "")) {
              setLocation(getStateCode(IpResponse?.country || "") || "", LocationType.Ip);
              return;
            }

            postIpStateHandler();
        } catch (error) {
            console.error("Error fetching IP state:", error);
        }
    };

    fetchIpState();
}
